<div class="ai-container" data-cy="accounting-integration">

    <div class="ai-header" data-cy="accounting-integration-header">
        Synchronize with Accounting System
    </div>


    <div class="ai-filters" data-cy="accounting-integration-filters">

        <div data-cy="accounting-integration-filters-container">
            <div data-cy="accounting-integration-filters-title">
                <span style="font-size: large;" data-cy="accounting-integration-filters-label">Filters</span>
            </div>

            <div style="display: flex; " data-cy="accounting-integration-filters-content">

                <div data-cy="accounting-integration-doctors-container">
                    <mat-button-toggle-group [(value)]="activeDoctor" data-cy="accounting-integration-doctors-toggle-group">
                        <mat-button-toggle *ngFor="let doc of listOfDoctors" [value]="doc" (click)="btnClickDoctor(doc)" data-cy="accounting-integration-doctor-toggle-{{doc.FullName}}">
                            <img [src]="doc.iconpath" style="width: 24px; height: 24px;" data-cy="accounting-integration-doctor-icon" />
                            {{doc.FullName}}
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>

                <div style="padding-left: 100px;" data-cy="accounting-integration-sync-container">
                    <button mat-button matTooltip="Syncronoze" data-cy="accounting-integration-sync-btn">
                        <img src="assets/icons/icons8_cloud_sync.svg" style="width: 36px; height: 36px;" data-cy="accounting-integration-sync-icon" />
                    </button> 
                </div>
            </div>    
        </div>
    </div>

    
    <div class="ai-trasactions" data-cy="accounting-integration-transactions">

        <div class="ai-tran-container" data-cy="accounting-integration-tran-container">
            <div class="ai-tran-transactions-table" data-cy="accounting-integration-transactions-table-container">
                <span style="font-size: large;" data-cy="accounting-integration-transactions-title">List of transactions</span>


                <table mat-table [dataSource]="listOfTransactions" data-cy="accounting-integration-transactions-table">

                        <ng-container matColumnDef="PatientNo" data-cy="accounting-integration-col-patient-no">
                        <th mat-header-cell *matHeaderCellDef data-cy="accounting-integration-header-patient-no"> Patient# </th>
                        <td mat-cell *matCellDef="let element" data-cy="accounting-integration-cell-patient-no"> {{element.PatientNo}} </td>
                        </ng-container>
                    
                        <ng-container matColumnDef="AIRef" data-cy="accounting-integration-col-ai-ref">
                        <th mat-header-cell *matHeaderCellDef data-cy="accounting-integration-header-ai-ref"> AI.Ref </th>
                        <td mat-cell *matCellDef="let element" data-cy="accounting-integration-cell-ai-ref"> {{element.AIRef }} </td>
                        </ng-container>
                    
                       
                        <ng-container matColumnDef="AICustomer" data-cy="accounting-integration-col-ai-customer">
                        <th mat-header-cell *matHeaderCellDef data-cy="accounting-integration-header-ai-customer"> AI.Customer </th>
                        <td mat-cell *matCellDef="let element" data-cy="accounting-integration-cell-ai-customer"> {{element.AICustomer}} </td>
                        </ng-container>
                    
                        <ng-container matColumnDef="LastTran" data-cy="accounting-integration-col-last-tran">
                        <th mat-header-cell *matHeaderCellDef data-cy="accounting-integration-header-last-tran"> Last.Tran </th>
                        <td mat-cell *matCellDef="let element" data-cy="accounting-integration-cell-last-tran"> {{element.LastTran}} </td>
                        </ng-container>
                    

                        <ng-container matColumnDef="NTC" data-cy="accounting-integration-col-ntc">
                            <th mat-header-cell *matHeaderCellDef data-cy="accounting-integration-header-ntc"> NTC </th>
                            <td mat-cell *matCellDef="let element" data-cy="accounting-integration-cell-ntc"> {{element.NTC}} </td>
                        </ng-container>

                        
                        <ng-container matColumnDef="RecType" data-cy="accounting-integration-col-rec-type">
                            <th mat-header-cell *matHeaderCellDef data-cy="accounting-integration-header-rec-type"> Rec.Type </th>
                            <td mat-cell *matCellDef="let element" data-cy="accounting-integration-cell-rec-type"> {{element.RecType}} </td>
                        </ng-container>

                        
                        <ng-container matColumnDef="PrevBalance" data-cy="accounting-integration-col-prev-balance">
                            <th mat-header-cell *matHeaderCellDef data-cy="accounting-integration-header-prev-balance"> Prev.Balance </th>
                            <td mat-cell *matCellDef="let element" data-cy="accounting-integration-cell-prev-balance"> {{element.PrevBalance}} </td>
                        </ng-container>

                        
                        <ng-container matColumnDef="TDObalance" data-cy="accounting-integration-col-tdo-balance">
                            <th mat-header-cell *matHeaderCellDef data-cy="accounting-integration-header-tdo-balance"> TDO Balance </th>
                            <td mat-cell *matCellDef="let element" data-cy="accounting-integration-cell-tdo-balance"> {{element.TDObalance}} </td>
                        </ng-container>
        
                        <ng-container matColumnDef="AIBalance" data-cy="accounting-integration-col-ai-balance">
                            <th mat-header-cell *matHeaderCellDef data-cy="accounting-integration-header-ai-balance"> AI.Balance </th>
                            <td mat-cell *matCellDef="let element" data-cy="accounting-integration-cell-ai-balance"> {{element.AIBalance}} </td>
                        </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns" data-cy="accounting-integration-header-row"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="getHighlightColor(row)" data-cy="accounting-integration-data-row"></tr>
                  </table>




            </div>

            <div class="ai-tran-transactions-logs" data-cy="accounting-integration-logs-container">
                 <span style="height: 10%; font-size: large;" data-cy="accounting-integration-logs-title">Sync Logs</span>
                 <div id="logTextDiv" style="height: 90%; overflow-y: scroll;" data-cy="accounting-integration-logs-content"></div>
            </div>
        </div>
    </div>

    <div class="ai-footer" data-cy="accounting-integration-footer">
         
            <p data-cy="accounting-integration-legend-title">Legend</p>
         
            <div class="legend-layout" data-cy="accounting-integration-legend-layout">
                <div class="legend-patient-not-found" data-cy="accounting-integration-legend-patient-not-found">Patient Not Found In Accounting: ( {{countPatientNotFound}} )</div>
                <div class="legend-balance" data-cy="accounting-integration-legend-balance">Balance not matching: ( {{countBalanceNotMatching}} )</div> 
                
                <div class="legend-patient-new-trans" data-cy="accounting-integration-legend-patient-new-trans">Patient with new transaction(s): ( {{countPatientNewTrans}} )</div>
            </div>
         

    </div>


</div>



<!-- 

<div class="header">
    Synchronize with Accounting System
</div>


<section>

    <div class="ai-filters">
        <h4>Filters     </h4>

        <mat-form-field class="doctor-slector">
            <mat-label>Doctor / Provider</mat-label>
            <mat-select [(value)]="seelctedDoctorID" >
                <mat-option value="0">None</mat-option>
                <mat-option value="1">All</mat-option>
                <mat-option value="2">Doctor 1</mat-option>
                <mat-option value="3">Doctor 2</mat-option>
            </mat-select>
        </mat-form-field>



    </div>


    <article>
        Grid with transacions

    </article>




</section>


<aside>
    logs
    
</aside>


<footer>
    <p>Footer</p>
</footer>
 -->
